import { useQueryApi } from 'utils/api'

import type { UseQueryOptions } from 'react-query'
import type {
  ParamsApiGetPelaksanaanList,
  ResponseApiGetPelaksanaanList,
  ResponseApiGetSchoolList,
} from 'types/kinerja-gpk'

const BASE_PATH = '/guru/skp'

// -------------------------------------
// Get Pelaksanaan School List for GPK
// -------------------------------------
export const API_GET_PELAKSANAAN_SCHOOL_LIST_QUERY_KEY =
  'API_GET_PELAKSANAAN_SCHOOL_LIST_QUERY_KEY'

export function useApiGetPelaksanaanSchoolList({
  options,
}: {
  options?: UseQueryOptions<ResponseApiGetSchoolList>
}) {
  const queryKey = [API_GET_PELAKSANAAN_SCHOOL_LIST_QUERY_KEY]

  return useQueryApi<ResponseApiGetSchoolList>(`${BASE_PATH}/v1/gpk/schools`, {
    queryConfig: {
      ...options,
    },
    queryKey,
  })
}

// -------------------------------------
// Get Pelaksanaan list
// -------------------------------------
export const API_GET_PELAKSANAAN_LIST_QUERY_KEY =
  'API_GET_PELAKSANAAN_LIST_QUERY_KEY'

export function useApiGetPelaksanaanList({
  params,
  options,
}: {
  params: ParamsApiGetPelaksanaanList
  options?: UseQueryOptions<ResponseApiGetPelaksanaanList>
}) {
  const queryKey = [
    API_GET_PELAKSANAAN_LIST_QUERY_KEY,
    params.skpYear,
    params.skpPeriod,
  ]

  return useQueryApi<ResponseApiGetPelaksanaanList>(
    `${BASE_PATH}/v1/gpk/pelaksanaan/list-guru/states`,
    {
      queryConfig: {
        ...options,
      },
      axiosConfig: {
        params: {
          skpYear: params.skpYear,
          skpPeriod: params.skpPeriod,
        },
      },
      queryKey,
    }
  )
}
